// @flow

import * as React from "react";
import Modal from "../organisms/Modal";
import QuickSearch from "../molecules/QuickSearch";

type PropsType = {
    active?: boolean,
    heading?: string,
    focusSearch?: boolean,
    postType?: string,
    defaultValue?: string,
    placeholder?: string,
    onClose?: Function,
    onSubmit?: Function,
};

const SearchModal = (props: PropsType): React.Node => {
    const handleSearchSubmit = searchValue => {
        if (props.onSubmit) {
            props.onSubmit(searchValue);
        }

        if (props.onClose) {
            props.onClose();
        }
    };

    return (
        <>
            <Modal
                aside={true}
                active={props.active}
                onClose={() => {
                    if (props.onClose) {
                        props.onClose();
                    }
                }}
            >
                <Modal.Header>{props.heading}</Modal.Header>
                <Modal.Content>
                    <div className="container-fluid">
                        <QuickSearch
                            postType={props.postType}
                            defaultValue={props.defaultValue}
                            placeholder={props.placeholder}
                            focusOnMount={props.focusSearch}
                            onSubmit={handleSearchSubmit}
                        />
                    </div>
                </Modal.Content>
            </Modal>
        </>
    );
};

export default SearchModal;
